module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"amaryllis\"-in-garden-grove-california-a15b5a78da176dcf14fd5c7d1308fe67.png";